import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'

@Pipe({
  name: 'safeUrl'
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string): SafeResourceUrl {
    const youtubeUrl = this.linkFormatChange(url)

    let videoUrl = youtubeUrl?.toString().replace('watch?v=', 'embed/')
    if (!videoUrl?.includes('https://www.')) {
      videoUrl = videoUrl?.replace('https://', 'https://www.')
    }

    if (videoUrl.indexOf('&') != -1) {
      videoUrl = videoUrl.substring(0, videoUrl.indexOf('&'))
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl)
  }

  linkFormatChange(url: any) {
    const videoId = this.extractVideoId(url)
    if (videoId) {
      return `https://www.youtube.com/watch?v=${videoId}`
    } else {
      return url
    }
  }

  extractVideoId(shortLink: string): string | null {
    const match = shortLink.match(/youtu\.be\/([a-zA-Z0-9_-]+)/)
    return match ? match[1] : null
  }
}
